import React from "react";
import { Badge } from "@/components/ui/badge";
import { TICKET_STATUS, ROLE_LABELS } from "@/lib/constants";
import { Inbox } from "lucide-react";

export const TicketBadge = ({ status }) => (
  <Badge variant="outline" className={TICKET_STATUS[status]?.cls} data-testid="ticket-status-badge">{TICKET_STATUS[status]?.label}</Badge>
);

const fmt = (iso) => new Date(iso).toLocaleString("ar-SA", { dateStyle: "short", timeStyle: "short" });

export function TicketList({ tickets, selectedId, onSelect, staff }) {
  if (!tickets.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-muted-foreground text-sm gap-2" data-testid="tickets-empty">
        <Inbox className="w-8 h-8 opacity-50" /> لا توجد تذاكر
      </div>
    );
  }
  return (
    <div className="divide-y divide-border" data-testid="tickets-list">
      {tickets.map((t) => {
        const unread = staff ? t.staff_unread : t.user_unread;
        return (
          <button key={t.id} type="button" onClick={() => onSelect(t.id)} data-testid={`ticket-item-${t.id}`}
            className={`w-full text-start p-4 transition-colors hover:bg-muted/50 ${selectedId === t.id ? "bg-primary/5 border-s-4 border-primary" : ""}`}>
            <div className="flex items-center justify-between gap-2 mb-1">
              <span className="font-semibold text-sm truncate flex items-center gap-2">
                {unread && <span className="w-2 h-2 rounded-full bg-accent shrink-0" data-testid="ticket-unread-dot" />}
                {t.subject}
              </span>
              <TicketBadge status={t.status} />
            </div>
            {!staff && t.status === "closed" && !t.rating && (
              <div className="text-xs text-amber-700 mb-1" data-testid={`ticket-rate-hint-${t.id}`}>بانتظار تقييمك ★</div>
            )}
            {t.rating && <div className="text-xs text-amber-600 mb-1" data-testid={`ticket-rating-${t.id}`}>{"★".repeat(t.rating)}</div>}
            {staff && (
              <div className="text-xs text-muted-foreground mb-1">{t.user_name} · {ROLE_LABELS[t.user_role]}</div>
            )}
            <div className="text-xs text-muted-foreground truncate">{t.last_preview}</div>
            <div className="text-[11px] text-muted-foreground mt-1 flex justify-between">
              <span>#{t.number}</span><span>{fmt(t.last_message_at)}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
